import styled from "styled-components";

export const STHR = styled.hr`
  margin: 0;
  padding: 0;
  border:  ${({ theme }) => theme.borders[5]};
`;
